<template>
    <div>
        <case-seo ref="seo"></case-seo>
        <banner-list ref="banner"></banner-list>
        <use-case ref="case"></use-case>
        <div class="title_btn">
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button type="primary" plain @click="$router.go(-1);">取消</el-button>
        </div>
    </div>
</template>
<script>

import { editCaseInfo, caseInfoDetail, addCaseInfo } from '@/api/case.js';
import utils from '@/jslibs/utils';
import CaseSeo from './components/caseSeo';
import BannerList from './components/bannerList';
import UseCase from './components/useCase';
export default {
    components: {
        CaseSeo,
        BannerList,
        UseCase
    },
    data() {
        return {
            id: "",
            caseInfo: {}
        };
    },

    created() {
        const id = this.$route.query.id;
        this.id = id;
        if (id) {
            this.caseInfoDetail(id)
        }
    },

    methods: {
        async caseInfoDetail(id) {
            const res = await caseInfoDetail(id);
            this.caseInfo = res;
            const seoInfo = {
                case_class_id: this.caseInfo.case_class_id,
                case_title: this.caseInfo.case_title,
                case_icon: this.caseInfo.case_icon,
                case_img: this.caseInfo.case_icon.split(),
                case_icon_alt: this.caseInfo.case_icon_alt,
                seo_t: this.caseInfo.seo_t,
                seo_d: this.caseInfo.seo_d,
                seo_k: this.caseInfo.seo_k
            }
            const bannerInfo = {
                case_sub_title: this.caseInfo.case_sub_title,
                function_introduction: this.caseInfo.function_introduction,
                purpose_introduction: this.caseInfo.purpose_introduction,
                business_pain_points: this.caseInfo.business_pain_points,
                solution: this.caseInfo.solution,
                implementation_effect: this.caseInfo.implementation_effect
            }
            this.caseInfo.banner_item.forEach((item, index) => {
                item.pc_banner = item.image ? item.image.split() : []
                item.h5_banner = item.h5_image ? item.h5_image.split() : []
            })

            this.caseInfo.scenarios_item.forEach((item, index) => {
                item.img_list = item.image.split()
            })

            this.$refs['seo'].seoInfo = seoInfo;
            this.$refs['banner'].bannerInfo = bannerInfo;
            this.$refs['banner'].banner_item = [...this.caseInfo.banner_item];
            this.$refs['banner'].num = this.caseInfo.banner_item.length;
            this.$refs['case'].scenarios_item = [...this.caseInfo.scenarios_item];
            this.$refs['case'].num = this.caseInfo.scenarios_item.length;
        },

        submit() {
            const seoVerify = this.$refs['seo'].verifyInput();
            if (seoVerify) {
                const bannerVerify = this.$refs['banner'].verifyInput();
                if (bannerVerify) {
                    const caseVerify = this.$refs['case'].verifyInput();
                    if (caseVerify) {
                        const seoInfo = this.$refs['seo'].seoInfo;
                        const bannerInfo = this.$refs['banner'].bannerInfo;
                        const sceneInfo = this.$refs['case'].sceneInfo;
                        const caseInfo = Object.assign({}, seoInfo, bannerInfo, sceneInfo);
                        this.confirmSubmit(caseInfo)
                    }
                }
            }
        },

        async confirmSubmit(caseInfo) {
            if (this.id) {
                const res = await editCaseInfo(this.id, caseInfo);
                if (res == true) {
                    this.$notify.success({ title: '案例编辑成功' });
                    this.$router.back();
                } else {
                    this.$notify.success({ title: '操作失败' });
                }
            } else {
                const res = await addCaseInfo(caseInfo);
                if (res == true) {
                    this.$notify.success({ title: '新增案例成功' });
                    this.$router.back();
                } else {
                    this.$notify.success({ title: '操作失败' });
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.form-item {
    display: flex;
    align-items: center;
    margin: 20px;
    .icon_type{
        margin-right: 20px;
    }
}
.label {
    display: inline-block;
    width: 180px;
    flex-shrink: 0;
}
.title_btn{
    margin-top: 50px;
}
</style>
